exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.animation[data-v-9ad75ec6] {\n  height: 0.75rem;\n  overflow: hidden;\n  width: 5.75rem;\n  margin: auto;\n}\n.animation li[data-v-9ad75ec6] {\n  display: block;\n  opacity: 1;\n  width: 5.75rem;\n  height: 0.75rem;\n  line-height: 0.5rem;\n  text-align: center;\n  color: white;\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n.animation li span[data-v-9ad75ec6] {\n  font-size: 0.6rem;\n  white-space: nowrap;\n  margin-top: 0;\n}\n.animation .start li[data-v-9ad75ec6] {\n  transform: translateY(-0.75rem);\n  transition: all 0.8s linear;\n}", ""]);

// exports
